import * as cartConstants from '../cartConstants';
import * as urlUtils from '../../../../utils/urlUtils';
import {contentConstants} from '../../Content';


/**
 * @param cartItem {object} Cart item
 * @return {string|null} Either populated link by cart item type or null, if no link can be derived
 */
function useCartItemLink(cartItem) {

    const {itemType} = cartItem;
    switch (itemType) {

        case cartConstants.CART_ITEM_TYPE_CONTENT:

            const {contentId} = cartItem;

            return urlUtils.buildPath(contentConstants.NAV_CONTENT_DETAIL_PAGE, {contentId});

        default:

            throw Error(`Cart item type ${itemType} not supported to build cart item link`);
    }
}


export default useCartItemLink;
